"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var router_1 = require("@angular/router");
var service_service_1 = require("src/app/Services/service.service");
var advertisement_service_1 = require("../../Services/advertisement.service");
var adv_user_advertisements_component_1 = require("../adv-user-advertisements/adv-user-advertisements.component");
var AdvUserAdvertisementsNonDemoComponent = /** @class */ (function (_super) {
    __extends(AdvUserAdvertisementsNonDemoComponent, _super);
    function AdvUserAdvertisementsNonDemoComponent(route, service) {
        var _this = _super.call(this, route, service) || this;
        _this.route = route;
        _this.service = service;
        return _this;
    }
    AdvUserAdvertisementsNonDemoComponent.prototype.ngOnInit = function () {
        if (!this.service.userService.isAdmin()) {
            this.service.route.navigate(["/"]);
        }
        if (!this.service.userService.isDemo()) {
            this.viewMode = advertisement_service_1.ViewMode.ACTIVE;
        }
        this.performSearch();
    };
    AdvUserAdvertisementsNonDemoComponent.prototype.performSearch = function () {
        this.service.advService.searchDataUserAdv.currentSearchRule.nonDemoOnly = true;
        this.service.advService.searchDataUserAdv.currentSearchRule.userId = null;
        this.service.advService.searchActionForUser(this.viewMode);
    };
    Object.defineProperty(AdvUserAdvertisementsNonDemoComponent.prototype, "pageEvent", {
        set: function (value) {
            this.service.advService.searchDataUserAdv.currentSearchRule.pageNumber = value.pageIndex;
            this.service.advService.searchDataUserAdv.currentSearchRule.pageSize = value.pageSize;
            this.service.advService.searchDataUserAdv.currentSearchRule.nonDemoOnly = true;
            this.service.advService.searchDataUserAdv.currentSearchRule.userId = null;
            this.service.advService.searchActionForUser(this.viewMode);
            this._pageEvent = value;
        },
        enumerable: true,
        configurable: true
    });
    return AdvUserAdvertisementsNonDemoComponent;
}(adv_user_advertisements_component_1.AdvUserAdvertisementsComponent));
exports.AdvUserAdvertisementsNonDemoComponent = AdvUserAdvertisementsNonDemoComponent;
